import React from 'react'
import { authRoles } from '../../auth/authRoles'
import { ORDER_PERMISSIONS } from 'app/constants/orderPermissions'

const orderListRoutes = [
    {
        path: '/order/newOrder',
        component: React.lazy(() => import('./NewOrder')),
        auth: authRoles.admin,
        accessPageName: 'NEWORDER',
        typeShow:['flower_shop']

    },
    {
        path: '/order/newOrderFastFood',
        component: React.lazy(() => import('./OrderFastFood/NewOrder')),
        auth: authRoles.admin,
        accessPageName: 'NEWORDER',
        typeShow:['fastfood']
    },
    {
        path: '/order/editOrderFastFood/([a-z0-9_]+)',
        component: React.lazy(() => import('./OrderFastFood/NewOrder')),
        auth: authRoles.admin,
        accessPageName: ORDER_PERMISSIONS.EDIT,
        matchPrefix: '/order/editOrderFastFood/',
        typeShow:['fastfood']
    },
    {
        path: '/order/allOrder',
        component: React.lazy(() => import('./AllOrder')),
        auth: authRoles.guest,
        typeShow:['flower_shop']
    },
    {
        path: '/order/allOrderFastFood',
        component: React.lazy(() => import('./AllOrderFastFood')),
        auth: authRoles.test,
        accessPageName: 'ALLORDER',
        typeShow:['fastfood']
    },
    {
        path: '/order/editOrder',
        component: React.lazy(() => import('./EditOrder')),
        auth: authRoles.admin,
        typeShow:['flower_shop']
    },
    {
        path: '/order/newOrderFast',
        component: React.lazy(() => import('./NewOrderFast')),
        auth: authRoles.sa,
        typeShow:['flower_shop']
    },
]

export default orderListRoutes
